import { useFormContext, useWatch } from 'react-hook-form';

import type { ScheduleFormFieldData } from './scheduleFormSchema';

/** The seeds plus the recurrence inputs — everything the preview reads. */
export type RecurrenceValues = Pick<
  ScheduleFormFieldData,
  | 'Count'
  | 'Ends'
  | 'FirstDueDate'
  | 'FirstStartDate'
  | 'Frequency'
  | 'Interval'
  | 'Repeat'
  | 'Until'
>;

export const useRecurrenceValues = (): RecurrenceValues => {
  const { control } = useFormContext<ScheduleFormFieldData>();
  const [
    FirstStartDate,
    FirstDueDate,
    Repeat,
    Frequency,
    Interval,
    Ends,
    Count,
    Until,
  ] = useWatch({
    control,
    name: [
      'FirstStartDate',
      'FirstDueDate',
      'Repeat',
      'Frequency',
      'Interval',
      'Ends',
      'Count',
      'Until',
    ],
  });

  return {
    FirstStartDate,
    FirstDueDate,
    Repeat,
    Frequency,
    Interval,
    Ends,
    Count,
    Until,
  };
};
